import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

import Home from '@/pages/Home'

export default new Router({
    mode: 'history',
    base: '/',
    routes: [
        {path: '/', redirect: {name: "Home"}},
        {
            path: '/:lang',
            name: 'Home',
            component: Home
        },
        {
            path: '/:lang/clause',
            name: 'Clause',
            component: () => import('../pages/Clause.vue')
        },
        {
            path: '/:lang/privacy',
            name: 'Privacy',
            component: () => import('../pages/Privacy.vue')
        },

        {
            path: '/:lang/cookiespolicy',
            name: 'CookiesPolicy',
            component: () => import('../pages/CookiesPolicy.vue')
        },

        {
            path: '/:lang/products',
            name: 'Product',
            component: () => import('../pages/Product.vue')
        },
        {
            path: '/product/detail',
            name: 'ProductDetail',
            component: () => import('../pages/ProductDetail.vue')
        },
        {
            path: '/:lang/support/service',
            name: 'Service',
            component: () => import('../pages/Service.vue')
        },
        {
            path: '/:lang/dms',
            name: 'Solution',
            component: () => import('../pages/Solution.vue')
        },
        {
            path: '/:lang/about-us',
            name: 'About',
            component: () => import('../pages/About.vue')
        },
        {
            path: '/:lang/search',
            name: 'Search',
            component: () => import('../pages/Search.vue')
        },
        {
            path: '/:lang/about/video',
            name: 'Video',
            component: () => import('../pages/Video.vue')
        },
        {
            path: '/:lang/about/news',
            name: 'News',
            component: () => import('../pages/News.vue')
        },
        {
            path: '/news/about/detail',
            name: 'NewDetail',
            component: () => import('../pages/NewDetail.vue')
        },
        {
            path: '/:lang/support/problem',
            name: 'Problem',
            component: () => import('../pages/Problem.vue')
        },
        {
            path: '/:lang/support/downloadcenter',
            name: 'DownloadCenter',
            component: () => import('../pages/DownloadCenter.vue')
        },
        {
            path: '/:lang/about/partner',
            name: 'Partner',
            component: () => import('../pages/Partner.vue')
        },
        {
            path: '/:lang/about/contact',
            name: 'Contact',
            component: () => import('../pages/Contact.vue')
        },

        {
            path: '/:lang/support/aftersales',
            name: 'AfterSales',
            component: () => import('../pages/AfterSales.vue')
        },
        {
            path: '/:lang/support/quality',
            name: 'Quality',
            component: () => import('../pages/Quality.vue')
        },
        {
            path: '/:lang/support/compatibility',
            name: 'Compatibility',
            component: () => import('../pages/Compatibility')
        },
        {
            path: '/:lang/support/verify',
            name: 'Verify',
            component: () => import('../pages/Verify')
        },
        {
            path: "*",
            component: Home
        },
    ]
})
